/**
 * @ngdoc services
 * @memberof mercury.modules.time
 * @name TimeLeaveAndUnavailability
 */
angular.module('mercury.modules.time.roster')
  .factory('TimeLeaveAndUnavailability', ["$http", "$q", "$resource", "userinfo", "settings", function ($http, $q, $resource, userinfo, settings) {

    const baseUrl = settings.mercHost + '/time';

    const Unavailability = $resource(baseUrl + '/unavailability');
    const LeaveRequests = $resource(baseUrl + '/leave-requests');
    const LeaveTypes = $resource(baseUrl + '/leave-types');

    function getAllUnavailabilityRecords(from, type, staffMemberId) {
      return Unavailability.query({from: from, type: type, staffMemberId: staffMemberId}).$promise;
    }

    function getAllLeaveRequests(from) {
      return LeaveRequests.query({from: from}).$promise;
    }

    function getAllLeaveTypes() {
      return LeaveTypes.query().$promise;
    }

    return {
      getAllUnavailabilityRecords,
      getAllLeaveRequests,
      getAllLeaveTypes
    }

  }]);